<template>
    <LoaderSplash :loaded="loaded">
        <b-container v-if="loaded">
            <b-row>
                <b-col>
                    <router-link class="my-3 d-inline-block" :to="{ name: 'event', params: { id: event.id }}">
                        Back to All Invites
                    </router-link>

                    <h2>
                        Edit the invitation for {{ invite.first_name }} {{ invite.last_name }} to {{ event.name }}
                    </h2>

                    <b-form @submit.prevent="onSubmit">
                        <b-form-group>
                            <label>
                                Status
                            </label>
                            
                            <b-form-select
                                v-model="form.status" :options="status_options">
                            </b-form-select>

                            <label>
                                First Name
                            </label>
                            
                            <b-form-input
                                type="text"
                                v-model="form.first_name"
                                required
                                disabled>    
                            </b-form-input>

                            <label>
                                Last Name
                            </label>
                            
                            <b-form-input
                                type="text"
                                v-model="form.last_name"
                                required
                                disabled>
                            </b-form-input>

                            <label>
                                Phone
                            </label>
                            
                            <b-form-input
                                type="text"
                                v-model="form.phone"
                                disabled>    
                            </b-form-input>

                            <label>
                                Email
                            </label>
                            
                            <b-form-input
                                type="text"
                                v-model="form.email"
                                required
                                disabled>    
                            </b-form-input>

                            <div v-for="custom_field in form.custom_fields" :key="custom_field.name">
                                <label>
                                    {{toTitleCase(custom_field.name)}}
                                </label>

                                <b-form-input
                                        type="text"
                                        v-model="custom_field.value">
                                </b-form-input>
                            </div>

                            <b-button type="submit" variant="primary">
                                Edit
                            </b-button>
                        </b-form-group>
                    </b-form>
                </b-col>
            </b-row>
        </b-container>
    </LoaderSplash>
</template>

<script>
    import inviteRepository from "@/repository/invites";

    export default {
        props: ['id', 'invite_id'],

        data() {
            return {
                event: null,
                invite: null,
                status_options: [
                    'UNSENT',
                    'SENT',
                    'VIEWED',
                    'ACCEPTED',
                    'REJECTED'
                ],
                form:{},
                loaded: false,
                errors: {}
            }
        },

        mounted() {
            inviteRepository.getById(this.invite_id,
                {
                    include: 'event'
                })
                .then(response => {
                    this.invite = response.data;
                    this.event = response.data.event;
                    this.loaded = true;

                    this.form = {...this.invite};
                });
        },

        // computed: {
        //     form() {
        //         return {
        //             ...this.invite
        //         }
        //     }
        // },

        methods: {
            onSubmit() {
                inviteRepository.update(this.form)
                    .then(response => {
                        this.$notify({
                            group: 'main',
                            type: 'success',
                            title: 'Invite edited',
                            text: 'Invite successfully edited.'
                        });
                    })
                    .catch(error => {
                        if (error.response.status == 422) {
                            let e = error.response.data.errors;

                            let errors = Object.keys(e).map(key => {
                                return e[key].join("<br/>");
                            }).join("<br/>");

                            this.$notify({
                                group: 'main',
                                type: 'error',
                                title: 'Form Errors',
                                text: errors,
                                duration: 10000,
                                width: '500px'
                            });
                        }
                    });
            },
            toTitleCase(str){
                return str.replace(/_/,' ').replace(/\b\S/g, t => t.toUpperCase());
            },
            sendInvite() {

            }
        }
    }
</script>

<style scoped lang="scss">
    input, select {
        margin-bottom: 20px!important;
    }

    select {
        margin-bottom: 10px;
    }
</style>